(function () {
  function init(scriptTag) {
    const sectionId = scriptTag.getAttribute('data-section-id');
    const mapScript = document.querySelector(`script[data-combo-image-map="${sectionId}"]`);
    const colorMapScript = document.querySelector(`script[data-color-image-map="${sectionId}"]`);

    let comboMap = {};
    if (mapScript) {
      try {
        comboMap = JSON.parse(mapScript.textContent) || {};
      } catch (e) {
        comboMap = {};
      }
    }

    let colorMap = {};
    if (colorMapScript) {
      try {
        colorMap = JSON.parse(colorMapScript.textContent) || {};
      } catch (e) {
        colorMap = {};
      }
    }

    // Classic product-page target (may not exist inside a Build a Box popup)
    const legacyGallery = document.getElementById(`MediaGallery-${sectionId}`);

    if (document.querySelectorAll('input[name="properties[color_1][]"]').length === 0) return;

    const COLOR_EQUIVALENTS = {
      "בלונד כהה": ["בלונד כהה", "בלונד בז'"],
      "בלונד בז'": ["בלונד בז'", "בלונד כהה"],
    };
    function getVariants(name) {
      return COLOR_EQUIVALENTS[name] || [name];
    }
    function cartesianProduct(arrays) {
      return arrays.reduce((acc, curr) => {
        const res = [];
        acc.forEach((a) => curr.forEach((c) => res.push([...a, c])));
        return res;
      }, [[]]);
    }

    function permute(arr) {
      if (arr.length <= 1) return [arr];
      const result = [];
      arr.forEach((item, i) => {
        const rest = arr.slice(0, i).concat(arr.slice(i + 1));
        permute(rest).forEach((p) => result.push([item, ...p]));
      });
      return result;
    }

    function findMagicMatchComboImages(values) {
      const lib = window.HAIR_PREVIEW_IMAGES;
      if (!lib) return null;
      const variantLists = values.map(getVariants);
      const combos = cartesianProduct(variantLists);
      for (const combo of combos) {
        const perms = permute(combo);
        for (const perm of perms) {
          for (const sep of ['/', '-']) {
            const key = perm.join(sep);
            const arr = lib[key];
            if (arr && arr.length) return arr;
          }
        }
      }
      return null;
    }

    function findMagicMatchSoloImages(v) {
      const lib = window.HAIR_PREVIEW_IMAGES;
      if (!lib) return null;
      for (const variant of getVariants(v)) {
        const arr = lib[variant];
        if (arr && arr.length) return arr;
      }
      return null;
    }

    // Per-container state (a "container" is either the legacy MediaGallery,
    // or a single Build a Box product's .portrait-slider wrapper). Keyed by
    // the element itself so multiple box products never clash.
    const navStates = new WeakMap();
    const overlayStates = new WeakMap();

    function isLegacyGallery(container) {
      return !!legacyGallery && container === legacyGallery;
    }

    function findThemeSliderButtons(container) {
      const productGallery = container.closest('product-gallery') || document.querySelector('product-gallery');
      if (!productGallery) return null;
      return productGallery.querySelector(':scope > .slider-buttons') || productGallery.querySelector('.slider-buttons');
    }

    function setThemeSliderButtonsHidden(container, hidden) {
      if (!isLegacyGallery(container)) return; // theme slider arrows are only a thing on the real product gallery
      const el = findThemeSliderButtons(container);
      if (!el) return;
      if (hidden) {
        if (el.dataset.wdComboHidden) return;
        el.dataset.wdComboHidden = '1';
        el.dataset.wdComboPrevPointerEvents = el.style.pointerEvents || '';
        el.dataset.wdComboPrevVisibility = el.style.visibility || '';
        el.style.pointerEvents = 'none';
        el.style.visibility = 'hidden';
      } else {
        if (!el.dataset.wdComboHidden) return;
        el.style.pointerEvents = el.dataset.wdComboPrevPointerEvents || '';
        el.style.visibility = el.dataset.wdComboPrevVisibility || '';
        delete el.dataset.wdComboHidden;
        delete el.dataset.wdComboPrevPointerEvents;
        delete el.dataset.wdComboPrevVisibility;
      }
    }

    function getActiveMediaWrap(container) {
      if (isLegacyGallery(container)) {
        const r = container.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) return container;
        return (
          container.querySelector('.product__media-item.is-active .product__media') ||
          container.querySelector('.product__media-item.is-active')
        );
      }
      // Build a Box: the portrait-slider wrap itself is the overlay target
      return container;
    }

    function getOrCreateOverlay(container) {
      const wrap = getActiveMediaWrap(container);
      if (!wrap) return null;

      const existing = overlayStates.get(container);
      if (existing && existing.wrap === wrap) return existing.img;

      teardownOverlay(container);

      if (window.getComputedStyle(wrap).position === 'static') {
        wrap.style.position = 'relative';
      }

      const img = document.createElement('img');
      img.className = 'wd-combo-overlay-img';
      img.style.cssText =
        'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:20;background:#fff;';
      wrap.appendChild(img);

      const hiddenEls = [];
      wrap.querySelectorAll(':scope > *:not(.wd-combo-overlay-img)').forEach((el) => {
        hiddenEls.push({ el, prevVisibility: el.style.visibility });
        el.style.visibility = 'hidden';
        if (el.tagName === 'VIDEO') {
          try { el.pause(); } catch (e) {}
        }
      });

      overlayStates.set(container, { wrap, img, hiddenEls });
      return img;
    }

    function teardownOverlay(container) {
      const state = overlayStates.get(container);
      if (!state) return;
      state.hiddenEls.forEach(({ el, prevVisibility }) => {
        el.style.visibility = prevVisibility;
      });
      if (state.img && state.img.parentNode) {
        state.img.parentNode.removeChild(state.img);
      }
      overlayStates.delete(container);
    }

    function teardownNav(container) {
      const state = navStates.get(container);
      if (state && state.controls && state.controls.parentNode) {
        state.controls.parentNode.removeChild(state.controls);
      }
      navStates.delete(container);
      setThemeSliderButtonsHidden(container, false);
    }

    // התמונה שמוצגת עכשיו בגלריה לפי הגוונים שנבחרו – נשמרת כדי לצרף קישור אליה להזמנה (product-form.js)
    function setShownShade(container, url) {
      window.__shzShadeImg = window.__shzShadeImg || {};
      if (isLegacyGallery(container)) window.__shzShadeImg[sectionId] = url || '';
      else if (container && container.dataset) container.dataset.shzShadeImg = url || '';
    }

    function teardownAll(container) {
      setShownShade(container, '');
      teardownNav(container);
      teardownOverlay(container);
    }

    function renderGalleryImages(container, images) {
      console.log('[wd-combo] renderGalleryImages() called with', images.length, 'image(s):', images);
      const wrap = getActiveMediaWrap(container);
      console.log('[wd-combo] active media wrap found:', !!wrap, wrap, 'rect:', wrap && wrap.getBoundingClientRect());
      if (!wrap) return;

      teardownNav(container);
      const img = getOrCreateOverlay(container);
      if (!img) return;
      img.src = images[0];
      console.log('[wd-combo] overlay <img> src set to:', images[0], img);
      setShownShade(container, images[0]);

      if (images.length <= 1) return;

      setThemeSliderButtonsHidden(container, true);

      let idx = 0;
      const controls = document.createElement('div');
      controls.className = 'wd-combo-gallery-controls';
      controls.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:33;';

      const navStyle =
        'position:absolute;top:50%;transform:translateY(-50%);background:rgba(0,0,0,0.45);color:#fff;border:none;border-radius:50%;width:32px;height:32px;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;pointer-events:auto;';
      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.setAttribute('aria-label', 'תמונה קודמת');
      prevBtn.style.cssText = navStyle + 'right:10px;';
      prevBtn.textContent = '›';

      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.setAttribute('aria-label', 'תמונה הבאה');
      nextBtn.style.cssText = navStyle + 'left:10px;';
      nextBtn.textContent = '‹';

      const dot = document.createElement('div');
      dot.style.cssText =
        'position:absolute;bottom:10px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.45);color:#fff;border-radius:99px;padding:2px 10px;font-size:12px;white-space:nowrap;pointer-events:none;';

      function render() {
        dot.textContent = (idx + 1) + '/' + images.length;
        img.src = images[idx];
      }
      function go(delta) {
        idx = (idx + delta + images.length) % images.length;
        render();
      }
      prevBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(-1); });
      nextBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(1); });

      controls.appendChild(prevBtn);
      controls.appendChild(nextBtn);
      controls.appendChild(dot);
      wrap.appendChild(controls);
      render();

      navStates.set(container, { controls });
    }

    // scopeEl: document for the classic product page, or a single .box-product
    // element when running inside a Build a Box popup — this is what keeps
    // each box product's checkboxes/images independent of the others.
    function updateGalleryImage(scopeEl, container) {
      const selected = Array.from(scopeEl.querySelectorAll('input[name="properties[color_1][]"]'))
        .filter((cb) => cb.checked)
        .map((cb) => cb.value);

      console.log('[wd-combo] updateGalleryImage() running, selected =', selected, 'container found:', !!container, container);

      if (!container) {
        console.log('[wd-combo] no container resolved — check that .portrait-slider / .ps-wrapper exists inside this .box-product');
        return;
      }

      if (selected.length === 0) {
        teardownAll(container);
        return;
      }

      if (selected.length === 1) {
        const [v1] = selected;
        const soloImages = findMagicMatchSoloImages(v1);
        const soloUrl = colorMap[v1];
        const images = soloImages || (soloUrl ? [soloUrl] : null);
        if (!images) {
          console.log('אין תמונת גוון בודד עבור:', v1);
          return;
        }
        renderGalleryImages(container, images);
        return;
      }

      if (selected.length === 2) {
        const [v1, v2] = selected;

        const dedicatedUrl = comboMap[v1 + '_' + v2] || comboMap[v2 + '_' + v1];
        const magicMatchImages = dedicatedUrl ? null : findMagicMatchComboImages(selected);
        const fallbackUrl = colorMap[v1] || colorMap[v2];

        const images = dedicatedUrl ? [dedicatedUrl] : (magicMatchImages || (fallbackUrl ? [fallbackUrl] : null));

        if (!images) {
          console.log('אין תמונת שילוב עבור:', v1, '+', v2);
          return;
        }

        renderGalleryImages(container, images);
        return;
      }

      const magicMatchImages = findMagicMatchComboImages(selected);
      if (magicMatchImages) {
        renderGalleryImages(container, magicMatchImages);
        return;
      }

      const [firstV] = selected;
      const soloImages = findMagicMatchSoloImages(firstV);
      const soloUrl = colorMap[firstV];
      const images = soloImages || (soloUrl ? [soloUrl] : null);
      if (!images) {
        console.log('אין תמונת שילוב עבור:', selected.join(' + '));
        return;
      }
      renderGalleryImages(container, images);
    }

    // Resolve which scope + container to use for a given checkbox that changed.
    function resolveContext(checkbox) {
      const box = checkbox.closest('.box-product');
      if (box) {
        const container = box.querySelector('.popup_left .portrait-slider .ps-wrapper')
          || box.querySelector('.portrait-slider .ps-wrapper')
          || box.querySelector('.portrait-slider');
        return { scopeEl: box, container };
      }
      return { scopeEl: document, container: legacyGallery };
    }

    document.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('input[name="properties[color_1][]"]')) {
        console.log('[wd-combo] delegated change matched, calling updateGalleryImage()');
        const { scopeEl, container } = resolveContext(e.target);
        updateGalleryImage(scopeEl, container);
      }
    }, true);

    window.addEventListener('haPreviewImagesReady', () => {
      console.log('[wd-combo] HAIR_PREVIEW_IMAGES ready — retrying update');
      const boxes = document.querySelectorAll('.box-product');
      if (boxes.length) {
        boxes.forEach((box) => {
          const container = box.querySelector('.popup_left .portrait-slider .ps-wrapper')
            || box.querySelector('.portrait-slider .ps-wrapper')
            || box.querySelector('.portrait-slider');
          updateGalleryImage(box, container);
        });
      } else {
        updateGalleryImage(document, legacyGallery);
      }
    });

    console.log('[wd-combo] init() finished for section', sectionId, '— build v-combo2');
  }

  document.querySelectorAll('script[src*="wd-color-combo-gallery.js"]').forEach(init);
})();